define('modules/common/filter/prossimaudienza',[], function() {
	var Filter = function($filter) {

		return function(fascicolo) {
			var result = [];
			if (fascicolo.dataprimaudienzafutura) {
				result.push($filter('date')(fascicolo.dataprimaudienzafutura, "dd/MM/yyyy") + " ore " + $filter('date')(fascicolo.dataprimaudienzafutura, "HH:mm"));
			}
			if (fascicolo.descrizioneprimaudienzafutura) {
				result.push(fascicolo.descrizioneprimaudienzafutura);
			}
			return result.join(" ");
		};

	};
	return ["$filter", Filter];
});
